/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Distance_TitleInputs */

const en_checkout_distance_title = /** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated Delivery Distance`)
};

const es_checkout_distance_title = /** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distancia Estimada de Entrega`)
};

const fr_checkout_distance_title = /** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance de livraison estimée`)
};

const de_checkout_distance_title = /** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Lieferentfernung`)
};

const id_checkout_distance_title = /** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimasi Jarak Pengiriman`)
};

/** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */
const ja_checkout_distance_title = en_checkout_distance_title;

/** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */
const zh_checkout_distance_title = en_checkout_distance_title;

/** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */
const ar_checkout_distance_title = en_checkout_distance_title;

/** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */
const it_checkout_distance_title = en_checkout_distance_title;

/** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */
const ru_checkout_distance_title = en_checkout_distance_title;

/** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */
const pt_checkout_distance_title = en_checkout_distance_title;

/** @type {(inputs: Checkout_Distance_TitleInputs) => LocalizedString} */
const ko_checkout_distance_title = en_checkout_distance_title;

/**
* | output |
* | --- |
* | "Estimated Delivery Distance" |
*
* @param {Checkout_Distance_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_distance_title = /** @type {((inputs?: Checkout_Distance_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Distance_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_distance_title(inputs)
	if (locale === "es") return es_checkout_distance_title(inputs)
	if (locale === "fr") return fr_checkout_distance_title(inputs)
	if (locale === "de") return de_checkout_distance_title(inputs)
	if (locale === "ja") return ja_checkout_distance_title(inputs)
	if (locale === "zh") return zh_checkout_distance_title(inputs)
	if (locale === "ar") return ar_checkout_distance_title(inputs)
	if (locale === "id") return id_checkout_distance_title(inputs)
	if (locale === "it") return it_checkout_distance_title(inputs)
	if (locale === "ru") return ru_checkout_distance_title(inputs)
	if (locale === "pt") return pt_checkout_distance_title(inputs)
	return ko_checkout_distance_title(inputs)
});